import styles from './pageheader.css'

const PageHeader = ({ title, subtitle }: { title: string; subtitle?: string }) => (
  <>
    <h1 className={styles.title}>{title}</h1>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
  </>
)

export default PageHeader
